import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import SummaryPrice from '../../common/components/summary-price'
import QueryString from 'query-string'
import QuoteNumber from '../../common/components/quote-number'
import Info from '../../common/components/info'
import { getQueryString, toCurrency, condition } from '../../common/util'
import { withProductData } from '../../common/modules/product-data'
import { withSubmission } from '../../common/modules/submission'
import { withFields } from '../../common/modules/fields'
import { withForm } from '../../common/modules/form'
import { withConfig } from  '../../common/modules/config'
import { withNavigation } from  '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { Table, Row, Cell, Alternate } from '../../common/components/summary-table'


export const formConfig = state => {
    const fields = state.fields;

    return {
        rules: {},
        predicates:{},
        options:{},
        inferred:{},
        transformOut: data => data
    }

}


@withForm(formConfig)
@withSubmission
@withFields
@withNavigation
@withConfig
@withProductData
@withRouteBlocker
@withScrollToTop
export default class extends React.Component<any, any> {

    componentWillMount(){

        const path = window.location.href;        

        if(this.props.fields.referred){
            const newPath = path+'?status=Referred'
            window.location.replace(newPath);
        }
        else if(this.props.fields.showPrice){
            const newPath = path + '?status=Quoted'
            window.location.replace(newPath);
        }
        else if(this.props.fields.indicativePrice){
            const newPath = path + '?status=IndicativePrice'
            window.location.replace(newPath);
        }


        if(this.props.fields.declined || this.props.fields.referred){
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3"
            ])
        }

        if(this.props.fields.declined){
            this.props.actions.navigation.changeRoute("/declined");
        }
    }


    render() {
        const fields = this.props.fields     
        const holidayLet = fields.holidayLet
        return (   
            <div className="row">
                <StepTitle>Here's The Cover You Requested</StepTitle>	
                <QuoteNumber />

                <StepBlock className="mt-4"><b>Your Protection Overview</b></StepBlock>
                <Table>
                    <Row highlight>
                        <Cell>Section 1 - Contents</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum Insured</Cell>
                        <Cell>${ toCurrency(fields.contentsSumInsured) }</Cell>
                    </Row>
                    <Row>
                        <Cell>Excess <Info title="Did you know?" message="You may be eligible for an excess waiver if your building is also insured by CHU. Please refer to the PDS for more information." /> </Cell>
                        <Cell>${ toCurrency(fields.contentsExcess) }</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 2 - Building</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum Insured</Cell>
                        <Cell>${toCurrency(fields.buildingSumInsured)}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 3 - Loss of Rentable Value</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Period of cover</Cell>
                        <Cell>{holidayLet == true ? 'Not Insured' : fields.lossOfRentableValueText}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 4 - Loss of Rent (departure by tenant)</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Period of cover</Cell>
                        <Cell>{fields.lossOfRentDepartureByTenantText}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 5 - Loss of Rent (default by tenant)</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Period of cover</Cell>
                        <Cell>{fields.lossOfRentDefaultByTenantText}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 6 - Legal Expenses</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum Insured</Cell>
                        <Cell>{holidayLet == true ? 'Not Insured' : "$" + toCurrency(fields.legalExpensesSumInsured)}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 7 - Liability to Others</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum Insured</Cell>
                        <Cell>${toCurrency(fields.liabilitySumInsured)}</Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Section 8 - Government Audit Costs</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>An investigation by the Australia Taxation Office or other statutory body</Cell>
                        <Cell>${toCurrency(fields.atoAuditExpenses)}</Cell>
                    </Row>
                    <Row>
                        <Cell>Record keeping audit</Cell>
                        <Cell>${toCurrency(fields.recordKeepingAuditExpenses)}</Cell>
                    </Row>
                </Table>
                <SummaryPrice
                    referred = { fields.referred }
                    totalPayable = { fields.totalPayable }
                    basePremium = { fields.basePremium }
                    levies = { fields.levies }
                    gst = { fields.gst }
                    stampDuty = { fields.stampDuty }
                    adminFee = { fields.adminFee }
                    brokerFee = { fields.brokerFee }
                    commission = { fields.commission }
                    commissionGst = { fields.commissionGst }
                    summaryText = { fields.summaryText }
                    actions = { this.props.actions }
                    referrals = {fields.referrals}
                    indicaticePrice = {fields.indicaticePrice}
                    indicativePriceText = {fields.indicativePriceText}
                />

                <Button.Container show={!fields.referred}>
                    <Button.Back route="/step-3" />
                    <Button.Save onClick={ this.save.bind(this) } />
                    <Button.BuyNow onClick={ this.proceed.bind(this) } />
                </Button.Container>
            </div>
        )
    }

    save(){
        this.props.actions.submission.save("/step-4", [
            formConfig
        ])
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-5")
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landlords/routes/step-4.tsx